import { AType, summon } from "@silversea-ssc/functional-support"
import { Semigroup } from "fp-ts/Semigroup"
import * as F from "fp-ts/function"
import * as ORD from "fp-ts/Ord"
import * as N from "fp-ts/number"
import { Currency } from "../currency"

export const Amount = summon((F) =>
    F.interface(
        {
            value: F.number(),
            currency: Currency(F),
        },
        "Amount",
    ),
)

export type Amount = AType<typeof Amount>
export const sum = (first: Amount, second: Amount): Amount => ({
    value: first.value + second.value,
    currency: first.currency, //TODO what happen if first's and second's currency are different?
})
export const subtract = (first: Amount, second: Amount): Amount => ({
    value: first.value - second.value,
    currency: first.currency, //TODO what happen if first's and second's currency are different?
})
export const cheapest = F.pipe(N.Ord, ORD.contramap(Amount.lensFromProp("value").get))
export const value = Amount.lensFromProp("value")
export const multiplyBy =
    (multiplier: number) =>
    (amount: Amount): Amount => ({
        value: amount.value * multiplier,
        currency: amount.currency,
    })
export const divideBy =
    (divider: number) =>
    (amount: Amount): Amount => ({
        value: amount.value / divider,
        currency: amount.currency,
    })
export const zero = (currency: Currency): Amount => Amount.build({ value: 0, currency: currency })
export const isZero = (amount: Amount): boolean => amount.value === 0
export const isZeroOrNegative = (amount: Amount): boolean => amount.value <= 0
export const isNegative = (amount: Amount): boolean => amount.value < 0
export const isPositive = (amount: Amount): boolean => amount.value > 0
export const SemigroupSum = <Semigroup<Amount>>{
    concat: sum,
}
export const opposite = ({ value, currency }: Amount): Amount => Amount.build({ currency, value: -value })
export const of = (value: number, currency: Currency): Amount => Amount.build({ value, currency })

export const build = Amount.build
export const eq = Amount.eq
export const strictType = Amount.strictType
